import { GET_HISTORY, GET_STAFF_HISTORY } from './history.type';

export const getHistory = (onModel, queryParams) => {
    return {
        type: GET_HISTORY,
        payload: { onModel, queryParams },
    };
};
export const getStaffHistory = (staffId, queryParams) => {
    return {
        type: GET_STAFF_HISTORY,
        payload: { staffId, queryParams },
    };
};
